import React, { useCallback, useRef, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { DeepTransLatorLanguages } from '../Translator.data'
import { Controller, useForm } from 'react-hook-form'
import DoSelectField from '../../../Form/Fields/DoSelectField'
import { Button } from 'primereact/button'
import fetchMethodRequest from '../../../../config/service'
import showToasterMessage from '../../../UI/ToasterMessage/toasterMessage'
import FilePreview from './FilePreview'
import { MoonLoader } from 'react-spinners'
import { saveAs } from "file-saver"
import { faDownload, faTimes } from '@fortawesome/free-solid-svg-icons'

export const TranslateFiles = (props) => {
  const { control, formState, watch, reset } = useForm()
  const { errors } = formState
  const [translatedFilePath, setTranslatedFilePath] = useState('')
  const [selectedLanguage, setSelectedLanguage] = useState("")
  const [originalFileName, setOriginalFilename] = useState("downloadFile.pdf")
  const [fileBuffer, setFileBuffer] = useState('')
  const [fileType, setFileType] = useState('')
  const [acceptedFiles, setAcceptedFiles] = useState([])
  const [errorMessage, setErrorMessage] = useState('')
  const language = watch('language')
  const fileInputRef = useRef(null)
  const [isLoading, setIsLoading] = useState(false)
  const [downloadInfo, setDownloadInfo] = useState(null)

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles?.length > 1) {
      setErrorMessage('Only one file can translate once')
    }
    // Validate accepted file types
    const isValid = acceptedFiles.every(file => {
      const validTypes = ['application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
      return validTypes.includes(file.type)
    })
    if (isValid) {
      setAcceptedFiles(acceptedFiles)
    } else {
      setErrorMessage('Please upload only PDF or DOCX files.')
    }

    acceptedFiles.forEach((file) => {
      const reader = new FileReader()
      reader.onload = () => {
        const binaryStr = reader.result
      }
      reader.readAsArrayBuffer(file)
    })

  }, [])

  const handleDownloadFromParent = () => {
    if (!downloadInfo?.blob) return
    saveAs(downloadInfo.blob, downloadInfo.filename)
  }

  const selectLanguage = {
    name: "language",
    fieldName: "language",
    type: "dropDown",
    placeholder: "Select Language",
    value: "",
    label: "Destination Language",
    width: "120px",
    addFormOrder: 6,
    editFormOrder: 10,
    stringType: null,
    derivedValue: "language=undefined",
    capitalizeTableText: false,
    sortable: false,
    filter: false,
    id: "language",
    displayinaddForm: "true",
    displayineditForm: "true",
    displayinregisterForm: "",
    displayinlist: "true",
    isFieldRequired: "false",
    required: false,
    displayOptionsInActions: "",
    globalSearchField: "true",
    controllerId: null,
    isClickable: "",
    isAddToIndex: false,
    isBulkUploadField: true,
    options: DeepTransLatorLanguages,
    fieldType: "dropDown",
    filterElement: DeepTransLatorLanguages,
    show: true,
    showOrHideFields: [],
    mobile: true,
    displayInSettings: true,
    isAddFormHidden: false,
    isEditFormHidden: false,
  }

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop
  })

  const handleClick = () => {
    fileInputRef.current.click()
  }

  let getDropdown = (item) => {
    return (
      <div>
        <Controller
          name={item.name}
          control={control}
          render={({ field, fieldState }) => (
            <DoSelectField
              input={field}
              markReq={item.required}
              id={field.id}
              name={field.name}
              field={field}
              label={item.label}
              fieldState={fieldState}
              errors={errors}
              options={item.options}
              optionLabel={item.optionLabel ? item.optionLabel : 'label'}
              placeholder={item.placeholder}
              item={item}
              screenName={'Translate'}
              setSelectedLanguage={setSelectedLanguage}
              optionValue="value"
            />)}
        />
      </div>
    )
  }

  const handleFilesUpload = (files) => {
    if (translatedFilePath || fileType || fileBuffer) {
      setTranslatedFilePath('')
      setFileBuffer('')
      setFileType('')
    }
    if (!language) {
      setErrorMessage('Please Select the Destination Language')
      return
    }
    setIsLoading(true)
    files.forEach((file, index) => {
      const formData = new FormData()
      formData.append('file', file)
      let url = 'chats/documentTranslation'
      if (language) {
        url = `chats/documentTranslation?language=${language}`
      }
      fetchMethodRequest("POST", url, formData, 'upload', true)
        .then(async (response) => {
          const translation = response.translations[0]
          if (translation.originalName) {
            setOriginalFilename(translation.originalName)
          }
          if (translation.translatedPath) {
            setTranslatedFilePath(translation.translatedPath)
            setFileType(translation.fileType)
            reset()
            if (fileInputRef.current) fileInputRef.current.value = ''
            setAcceptedFiles([])
          }

          if (translation.fileBuffer) {
            setFileBuffer(translation.fileBuffer)
            setFileType(translation.fileType)
            reset()
            if (fileInputRef.current) fileInputRef.current.value = ''
            setAcceptedFiles([])
          }
          setIsLoading(false)
        }).catch((err) => {
          setIsLoading(false)
          console.log('err', err)
        })
    })
  }

  const handleTranslateButton = () => {
    if (acceptedFiles.length > 0) {
      handleFilesUpload(acceptedFiles)
    }
  }

  const closePreview = () => {
    setTranslatedFilePath("")
    setFileBuffer("")
    setFileType("")
    setDownloadInfo(null)
  }

  return (
    <div className="container-fluid vh-100 overflow-hidden">

      <div className="row">
        {/* Left Panel - Upload Section */}
        <div className={`${(fileBuffer || translatedFilePath) && fileType ? 'col-lg-6 col-md-12' : 'col-12'}`} style={{ height: "calc(100vh - 120px)" }}>
          <div className="card shadow-sm border-0">
            <div className="card-body p-4">
              <div className="row mb-4">
                <h2 className="mb-4" style={{
                  "color": " #12225f",
                  "fontSize": "30px",
                  "fontWeight": "700"
                }}>Translate Files</h2>
                <div className="col-md-6">
                  <div className="mb-3">
                    {getDropdown(selectLanguage)}
                  </div>
                </div>
              </div>

              <div className="row mb-4">
                <div className="col-12">
                  <div className="text-center">
                    <div
                      {...getRootProps()}
                      className={`dropzone-container ${isDragActive ? 'active' : ''}`}
                      onClick={handleClick}
                      style={{ cursor: 'pointer' }}
                    >
                      <input {...getInputProps()} ref={fileInputRef} multiple />
                      <div className="py-5 px-3">
                        <div className="mb-3">
                          <FontAwesomeIcon
                            icon={faCloudUploadAlt}
                            size="3x"
                            className={`text-primary ${isDragActive ? 'animate-bounce' : ''}`}
                          />
                        </div>
                        <div className="text-center">
                          <p className="mb-2 fw-bold">
                            {acceptedFiles[0]?.name ? `Selected: ${acceptedFiles[0]?.name}` : "Drag & drop files here"}
                          </p>
                          <p className="text-muted small">
                            Supports PDF and DOCX files
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {errorMessage && (
                <div className="row mb-3">
                  <div className="col-12">
                    <div className="alert alert-danger alert-dismissible fade show py-2" role="alert">
                      <small>{errorMessage}</small>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setErrorMessage('')}
                        aria-label="Close"
                      ></button>
                    </div>
                  </div>
                </div>
              )}

              <div className="row mt-4">
                <div className="col-12">
                  <div className="d-flex flex-wrap gap-2 justify-content-end">
                    {downloadInfo?.blob && (
                      <>
                        <Button className='gap-1' icon={<FontAwesomeIcon icon={faDownload} size="1x" title="Download" />} onClick={handleDownloadFromParent} label='Download'>
                        </Button>
                        <Button onClick={closePreview} className='gap-1' icon={<FontAwesomeIcon icon="sync-alt" size="1x" title="Close Preview" />} label='Reset'>
                        </Button>
                      </>
                    )}

                    {isLoading ?
                      <Button>Translating &nbsp; <MoonLoader color='#fff' size={18} /> </Button>
                      : <Button onClick={handleTranslateButton} disabled={!(language && acceptedFiles?.length > 0)}>Translate</Button>}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Panel - Preview Section */}
        {(fileBuffer || translatedFilePath) && fileType && (
          <div className="col-lg-6 col-md-12 mt-lg-0 mt-3">
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body p-0">
                <FilePreview
                  {...(fileBuffer ? { fileBuffer } : {})}
                  translatedFilePath={translatedFilePath}
                  fileType={fileType}
                  closePreview={closePreview}
                  selectedLanguage={selectedLanguage}
                  originalFileName={originalFileName}
                  onReadyToDownload={setDownloadInfo}
                />
              </div>
            </div>
          </div>
        )}
      </div>

      <style jsx>{`
        .dropzone-container {
          border: 2px dashed #dee2e6;
          border-radius: 10px;
          background-color: #f8f9fa;
          transition: all 0.3s ease;
        }
        
        .dropzone-container:hover {
          background-color: #e9ecef;
          border-color: #0d6efd;
        }
        
        .dropzone-container.active {
          border-color: #0d6efd;
          background-color: #e7f3ff;
        }
        
        .animate-bounce {
          animation: bounce 1s infinite;
        }
        
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        
        :global(.btn) {
          border-radius: 6px;
        }
      `}</style>
    </div>
  )
}
